import { addColumnHeader } from "../helpers";
export const insertCloneColumnDataInSheet = (
  outputSheet,
  outputColumns,
  rule,
) => {
  addColumnHeader(outputSheet, outputColumns, rule.outColChr);

  const colClone = outputSheet.getColumn(rule.cloneColumn).values;

  for (let i = 2; i < colClone.length; i++) {
    outputSheet.getCell(`${rule.outColChr}${i}`).value = colClone[i];
  }
};
